import Parse from "/server/parse-server.js";
import locationId from "/server/parse-location.js";
import { LocationObject } from "/server/parse-location.js";
import { formatPhone } from "/reusable/string.js";
import { goToNextPage } from "/reusable/navigation.js";

"use strict";
window.Webflow ||= [];
window.Webflow.push(async () => { 

    const receiveOfferButton = document.getElementById('receiveOfferButton');
    const headerLabel = document.getElementById('headerLabel');
    const bottomLabel = document.getElementById('bottomLabel');
    const progressModal = document.getElementById('progressModal');
    const verifyModal = document.getElementById('verifyModal');
    const verifyTopLabel = document.getElementById('verifyTopLabel');
    const verifyPhoneTextField = document.getElementById('verifyPhoneTextField');
    const resendCodeButton = document.getElementById('resendCodeButton');
    const verifySmsButton = document.getElementById('verifySmsButton');
    const closeVerifyButton = document.getElementById('closeVerifyButton');
    

    var referralId;
    var initialamount = 15;
    var locationObject = await LocationObject();

    function setUpHeaderLabel() {
        const currentUser = Parse.User.current();
        if (currentUser != null) {
            const firstName = currentUser.get('firstname');
            if (firstName != null) {
                headerLabel.innerText = "HEY " + firstName.toUpperCase() + ", HERE'S 15% OFF ONE ORDER";
                bottomLabel.innerText = "REQUIRED TO VERIFY PHONE NUMBER TO RECEIVE OFFER";
                receiveOfferButton.innerText = "ADD OFFER TO BOX";
            } else {
                headerLabel.innerText = "15% OFF ONE ORDER";
                bottomLabel.innerText = "REQUIRED TO CREATE ACCOUNT AND VERIFY PHONE NUMBER TO RECEIVE OFFER";
                receiveOfferButton.innerText = "CREATE ACCOUNT";
            }
        } else {
            headerLabel.innerText = "15% OFF ONE ORDER";
             bottomLabel.innerText = "REQUIRED TO CREATE ACCOUNT AND VERIFY PHONE NUMBER TO RECEIVE OFFER";
            receiveOfferButton.innerText = "CREATE ACCOUNT";
        }
    }
    setUpHeaderLabel();

    receiveOfferButton.addEventListener('click', async () => {

        const initialActive = locationObject.get('initialofferbool');
        if (initialActive) {
            const currentUser = Parse.User.current();
            if (currentUser != null) {
                const anonymous = currentUser.get('anonymous');
                if (!anonymous) {
                    const phone = currentUser.get('phonenumber');
                    setUpPhoneVerify(phone);
                } else {
                    sessionStorage.setItem('offer', 'Welcome15');      
                    goToNextPage('/create-account');
                }
            } else {
                sessionStorage.setItem('offer', 'Welcome15');
                goToNextPage('/create-account');
            }
        } else {
            alert('Offer is no longer available');
        }
    });

    // MARK: - VERIFY PHONE
    var phoneNumber;
    var codeSent = false;

    $("#verifyForm").submit(() => { return false; });

    function setUpPhoneVerify(phone) {
        phoneNumber = phone;
        verifyPhoneTextField.value = formatPhone(phone);
        verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER - VALID ONE TIME PER CUSTOMER';
        verifyModal.style.display = 'flex';
    }

    resendCodeButton.addEventListener('click', async () => {
        resetView();
    });

    verifySmsButton.addEventListener('click', async () => {
        if (codeSent === false) {
            phoneNumber = verifyPhoneTextField.value.replace(/\D/g, '');
            var error = '';
            if (phoneNumber.length != 10) {
                error = 'Please enter full 10 digits';
            }
            if (error != '') {
                alert(error);
            } else {
                checkPhoneNumber(phoneNumber);
            }
        } else {
            // verify with code
            const code = verifyPhoneTextField.value;
            var error = '';
            if (code.length != 6) {
                error = 'Please enter 6 digit code sent in SMS';
            }
            if (error != '') {
                alert(error);
            } else {
                verifyPhoneNumber(phoneNumber, code);
            }
        }
    });

    closeVerifyButton.addEventListener('click', async () => {
        verifyModal.style.display = 'none';
    });

    async function verifyPhoneNumber(phone, code) {
        progressModal.style.display = 'flex';
        try {
            const status = await Parse.Cloud.run('verifyTextCodeWeb', {'phone':phone, 'code': code});
            if (status === 'approved') {
                const request = {'phone': phoneNumber, 'initialamount': initialamount, 'locationid': locationId};
                await Parse.Cloud.run('updateUserVerificationAndRefferal', request);

                const currentUser = Parse.User.current();
                if (currentUser != null) {
                    await currentUser.fetch();
                }
                sessionStorage.removeItem("offer");
                alert('Success! 15% will be applied at check out - expires in 7 days');
                goToNextPage('/profile');
            } else {
                alert('Code failed please try again');
            }
        } catch(e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    
    async function checkPhoneNumber(phone) {
        progressModal.style.display = 'flex';
        try {
            const available = await Parse.Cloud.run('checkPhoneNumber', {"phone":phone});
            if (available == true) {
                await sendCode(phone);
            } else {
                alert('Offer already redeemed by this phone number');
            }
        } catch(e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    
    async function sendCode(phone) {
        const status = await Parse.Cloud.run('sendTextVerificationWeb', {"phone":phone});
        if (status === "pending") {
            verifyPhoneTextField.value = '';
            verifyPhoneTextField.placeholder = 'Enter Code';
            verifyTopLabel.innerText = 'ENTER 6 DIGIT CODE'
            resendCodeButton.style.display = 'block';
            verifySmsButton.value = 'VERIFY';
            verifyPhoneTextField.focus();
            codeSent = true;
        } else {
            alert('Code failed to send');
        }
    }
   
    async function resetView() {
        verifyPhoneTextField.value = formatPhone(phoneNumber);
        verifyTopLabel.innerText = 'TO RECEIVE THIS OFFER YOU MUST VERIY PHONE NUMBER VIA SMS';
        resendCodeButton.style.display = 'none';
        verifySmsButton.value = 'SEND SMS CODE';
        codeSent = false;
    
        verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        
        if (referralId != null) {
            verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
        }
    }

});